import {
  Avatar,
  Grid2,
  IconButton,
  LeftIcon,
  RightIcon,
  Show,
  Typography,
  XIcon,
} from "components";
import { useRef } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { WebsiteDetails } from "../types";

const TestimonialsSection = () => {
  const form = useFormContext<WebsiteDetails>();
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const testimonials = useWatch({
    control: form.control,
    name: "websiteSection.testimonials",
  });

  const handleScroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -350 : 350,
        behavior: "smooth",
      });
    }
  };

  const showScrollControls = (testimonials?.length ?? 0) >= 4;

  return (
    <Grid2
      container
      width="100%"
      spacing={5}
      maxWidth={{ xs: "100vw", md: "1192px" }}
      position="relative"
    >
      <Grid2 size={12}>
        <Typography
          textAlign="center"
          fontSize={`clamp(1rem, -0.25rem + 4vw, 2rem)`}
          fontWeight={600}
          lineHeight="normal"
        >
          Real Stories. Real Growth.
        </Typography>
        <Typography
          textAlign="center"
          fontSize={14}
          color="#697586"
          lineHeight="normal"
        >
          See how investors like you turned plans into progress with
          expert-backed strategies.
        </Typography>
      </Grid2>

      <Grid2 size={12}>
        <div
          ref={scrollRef}
          style={{
            display: "flex",
            gap: "16px",
            overflowX: "auto",
            scrollBehavior: "smooth",
            paddingBottom: "10px",
          }}
        >
          {testimonials?.map((testimonial, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 auto",
                width: "380px",
              }}
            >
              <Grid2
                container
                border="solid 1px #D5DEE5"
                bgcolor="#fff"
                p={2}
                borderRadius={2}
                spacing={1}
              >
                <Grid2 size="auto">
                  <Avatar
                    src={
                      testimonial?.clientsImage ||
                      "https://flowbite.com/docs/images/carousel/carousel-1.svg"
                    }
                  />
                </Grid2>
                <Grid2
                  size="grow"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                >
                  <Typography fontWeight={600} lineHeight="normal">
                    {testimonial?.name}
                  </Typography>
                  <Typography lineHeight="normal" fontSize={12}>
                    {testimonial?.twitterUsername}
                  </Typography>
                </Grid2>
                <Show.When isTrue={!!testimonial?.twitterLink}>
                  <Grid2
                    size="auto"
                    display="flex"
                    alignItems="start"
                    justifyContent="center"
                  >
                    <XIcon width={18} height={18} />
                  </Grid2>
                </Show.When>
                <Grid2 size={12}>
                  <Typography lineHeight="normal" fontSize={12}>
                    {testimonial?.clientsReview}
                  </Typography>
                </Grid2>
              </Grid2>
            </div>
          ))}
        </div>
      </Grid2>

      {/* Show scroll arrows only when 4+ cards */}
      <Show.When isTrue={showScrollControls}>
        <Grid2
          size={12}
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          gap="10px"
        >
          <IconButton onClick={() => handleScroll("left")}>
            <LeftIcon />
          </IconButton>
          <IconButton onClick={() => handleScroll("right")}>
            <RightIcon />
          </IconButton>
        </Grid2>
      </Show.When>
    </Grid2>
  );
};

export default TestimonialsSection;
